var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white p-3"},[_c('h3',{staticClass:"mb-2"},[_vm._v("Veelgestelde vragen")]),_vm._v(" "),_c('ul',_vm._l((_vm.questions),function(question,key){return _c('Question',{key:key,attrs:{"question":question}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }